import { render, staticRenderFns } from "./CheckVaccinesClass.vue?vue&type=template&id=692c352e&scoped=true"
import script from "./CheckVaccinesClass.vue?vue&type=script&lang=js"
export * from "./CheckVaccinesClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692c352e",
  null
  
)

export default component.exports